<template>
  <main>
    <section class="section">
      <div class="container">
        <div class="section__block">
          <h1 class="text-center mb-5 headline--underlined">Alle Veranstaltungen</h1>
        </div>
        <div class="section__block">
          <div class="row justify-content-center">
            <div v-for="event in events" :key="event.id" class="col-12 col-md-6 col-lg-4">
              <div
                  class="teaser teaser--vertical"
              >
                  <div class="teaser__meta">
                    <span class="teaser__meta--large">{{ getEventDay(event.eventDate) }}</span>
                    <span>{{ getEventMonthYear(event.eventDate) }}</span>
                  </div>
                  <div class="teaser__content">
                    <h3>{{ event.title }}</h3>
                    <p>{{ event.text }}</p>
                    <a v-if="event.link !== ''" :href="event.link" class="link link--internal">zur Website</a>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>

import {onMounted, ref} from "vue";
import axios from 'axios';

export default {
  setup() {

    const events = ref([]);

    const fetchData = async () => {
      try {
        const response = await axios.get('http://localhost:8082/gemeinde/events/all');
        events.value = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    const getEventDay = (date) => {
      const dateFormatted = new Date(date);
      const day = dateFormatted.getDate().toString().padStart(2, '0');
      return `${day}.`;
    }

    const getEventMonthYear = (date) => {
      const dateFormatted = new Date(date);
      const month = (dateFormatted.getMonth() + 1).toString().padStart(2, '0'); // getMonth is 0-based
      const year = dateFormatted.getFullYear();
      const formattedDate = `${month}.${year}`;
      return formattedDate;
    }

    onMounted(() => {
      fetchData()
    })

    return {
      events,
      getEventDay,
      getEventMonthYear
    };
  }
}
</script>

<style></style>
